export default __webpack_public_path__ + "static/media/Aseer.2bca4e1e.mp4";